import { MeterGroup } from 'primereact/metergroup';

type PodiumItem = { label: string; valor: number };

// Posições visuais do pódio: prata à esquerda, ouro ao centro, bronze à direita.
const POSICOES = [
  { indice: 1, medalha: '🥈', bg: '#C0C0C0', altura: '4.5rem', fonte: '0.85rem' },
  { indice: 0, medalha: '🥇', bg: '#FFD700', altura: '6rem', fonte: '0.95rem' },
  { indice: 2, medalha: '🥉', bg: '#CD7F32', altura: '3.5rem', fonte: '0.8rem' },
];

/**
 * Painel de ranking (pódio + lista com barras de proporção) reutilizado nos
 * gráficos de comissão e de quantidade de consultas por representante/cliente.
 */
export default function PodiumPanel({
  titulo,
  itens,
  formatar,
}: {
  titulo: string;
  itens: PodiumItem[];
  formatar: (valor: number) => string;
}) {
  const ordenado = [...(itens || [])].sort((a, b) => b.valor - a.valor);
  const total = ordenado.reduce((acc, i) => acc + i.valor, 0);

  return (
    <div className="card" style={{ height: '28rem', overflowY: 'auto' }}>
      <h5 style={{ marginTop: 0 }}>{titulo}</h5>

      {ordenado.length === 0 && (
        <p style={{ color: '#888', fontSize: '0.85rem' }}>Sem dados no período.</p>
      )}

      {ordenado.length > 0 && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', gap: '0.5rem', marginBottom: '1rem' }}>
          {POSICOES.map((pos) => {
            const item = ordenado[pos.indice];
            if (!item) return null;
            return (
              <div key={pos.indice} style={{ textAlign: 'center', width: '30%' }}>
                <span style={{ fontSize: '0.75rem', fontWeight: 'bold', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.label}</span>
                <div style={{ background: pos.bg, borderRadius: '6px 6px 0 0', height: pos.altura, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', color: '#fff' }}>
                  <span style={{ fontSize: '1.8rem', fontWeight: 'bold' }}>{pos.medalha}</span>
                  <span style={{ fontWeight: 'bold', fontSize: pos.fonte }}>{formatar(item.valor)}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}

      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {ordenado.map((item, index) => {
          const percentual = total > 0 ? Math.round((item.valor / total) * 100) : 0;
          return (
            <li key={index} style={{ padding: '0.3rem 0' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>{item.label}</span>
                <span style={{ fontWeight: 'bold' }}>{formatar(item.valor)} ({percentual}%)</span>
              </div>
              <MeterGroup labelPosition="start" values={[{ value: percentual, color: '#0b655b' }]} labelList={() => <></>} />
              <br />
            </li>
          );
        })}
      </ul>
    </div>
  );
}
